import styled, { css } from 'styled-components';
import { BaseColumn, MainContainer, StyledRow } from '../../../components/shared/sharedStyles.styles';
import { ButtonForm } from '../../../components/shared/formStyles.styled'

export const GrayLine = styled(BaseColumn)`
  height: .05rem;
  background-color: ${props => props.theme['color_border-light-gray']};
  margin: ${props => props.margin? props.margin : '1rem 0'};

  @media(max-width: 800px){
    display: none;
  }
`;

export const LimitTitle = styled.div`
  padding: .2rem .9rem;
  text-align: center;
  font-size: 12px;
  color: #64748b;
  background: #f8fafc;
  border: 1px solid rgba(21, 43, 78, 0.1);
  border-radius: 999px;
  letter-spacing: .03em;
  font-weight: 600;

  @media(max-width: 800px){
    padding: .5rem 0 .7rem 0;
    border: 0;
    border-radius: 0;
    background: transparent;
  }
`;

export const LimitTitleBold = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #152b4e;
`;

export const ButtonBar = styled(ButtonForm)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 .85rem;
  font-size: 12px !important;
  font-weight: 500;
  line-height: 1;
  margin: 6px 0 0 .75rem;
  align-self: center;

  &.botao-novo-usuario {
    position: relative;
    top: 8px;
  }
`;

export const StyledSelect = styled.select`
  margin-top: 10%;
  margin-bottom: 10%;
  width: 50%;
  background-color: transparent;
  border: none;
  border-bottom: solid 1px ${props => props.theme.color_gray};
  color: ${props => props.theme.color_gray};
  font-size: 14px;
  &:focus {
    outline: none;
    
  }`;

  export const StyledMainContainer = styled(MainContainer)`
    @media(max-width: 800px){
      margin-top: 55px;
      padding: 0;
      width: 95%;
    }

    tbody {
      border-bottom: none;
    }
  `;

  export const StyledMobileRow = styled(StyledRow)`
    background: #fff;
    border: 1px solid rgba(21, 43, 78, 0.08);
    border-radius: 14px;
    box-shadow: 0 4px 20px rgba(21, 43, 78, 0.07);
    padding: 10px 14px 12px;
    margin-bottom: 14px;

    .limits-top-row {
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      gap: 12px;
      flex-wrap: nowrap;
    }

    .limits-stats-row {
      margin-top: 2px;
      align-items: center !important;
      gap: 8px;
    }

    .limits-metric-col {
      padding: 0 !important;
    }

    .limits-metric-col-right {
      justify-content: flex-end;
    }

  @media (min-width: 801px) {
    .limits-top-row {
      position: relative;
      justify-content: center;
    }

    .limits-top-row .botao-novo-usuario {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      margin: 0;
    }

    .limits-stats-row {
      flex-direction: column;
      align-items: center !important;
      gap: 10px;
      width: 100%;
    }

    .limits-metric-col,
    .limits-metric-col-right {
      flex: 0 0 100%;
      max-width: 100%;
      padding: 0 !important;
      justify-content: center;
    }

    .limits-metrics-stack {
      width: 100%;
      max-width: 760px;
      margin: 0 auto;
      padding: 0 !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }

    .limits-metrics-stack .disponivel-alocar,
    .limits-metrics-stack .total-utilizado,
    .limits-metrics-stack .disponivel-funcionarios {
      width: 100%;
      justify-content: center;
      text-align: center;
    }
  }

    .disponivel-alocar,
    .total-utilizado,
    .disponivel-funcionarios {
      background: #f8fafc;
      border: 1px solid rgba(21, 43, 78, 0.1);
      border-radius: 10px;
      padding: 7px 10px;
      color: #475569 !important;
      font-size: 11px !important;
      font-weight: 600;
      line-height: 1.3;
    }

    .disponivel-alocar::before,
    .total-utilizado::before,
    .disponivel-funcionarios::before {
      width: .5rem !important;
      height: .5rem !important;
      border-radius: 99px;
      margin-right: .45rem !important;
      margin-top: 1px;
    }

    .disponivel-alocar > div,
    .total-utilizado > div,
    .disponivel-funcionarios > div {
      color: #152b4e;
      font-weight: 700 !important;
    }

    @media(max-width: 800px){
      background-color: #f8f6f6 !important;
      margin-bottom: 20px;
      position: relative;
      border: 0;
      box-shadow: none;
      padding: 0;

      .limits-top-row,
      .limits-stats-row {
        flex-wrap: wrap;
        width: 100%;
      }

      .limits-top-row {
        justify-content: center;
        row-gap: 10px;
      }

      .limits-stats-row {
        margin-top: 4px;
        row-gap: 6px;
      }

      .limits-metric-col,
      .limits-metric-col-right {
        flex: 0 0 100%;
        max-width: 100%;
        justify-content: center;
      }

      .disponivel-alocar,
      .total-utilizado,
      .disponivel-funcionarios {
        width: 100%;
        padding: 8px 10px;
        border: 1px solid rgba(21, 43, 78, 0.1);
        background: #fff;
        border-radius: 10px;
        justify-content: center;
        text-align: center;
      }

      .limits-metrics-stack {
        width: 100%;
        margin: 0;
        padding: 0 !important;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 6px;
      }
    }
  `;
  export const StyledBaseColumn = styled(BaseColumn)`
    padding: 0;
    @media(max-width: 800px){
      padding: 0.5rem;
    }
  `;

  export const CreditBarWrapper = styled.div`
    width: 100%;
  `;

  export const NewUserButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    position: fixed;
    right: 20px;
    bottom: 30px;
    font-size: .8rem;
    margin-top: .5rem;
    padding: .25rem 1.5rem .25rem 1.5rem;
    z-index: 1;
    background-color: #ffffff;
    width: 45px;
    height: 45px;
    border-radius: 45px;
    ${({customstyle}) => customstyle}

    /* Evita sobrepor o .whatsapp-button (fixed bottom/right ~15px + ícone ~56px). */
    @media (max-width: 800px) {
      bottom: calc(88px + env(safe-area-inset-bottom, 0px));
      right: max(16px, env(safe-area-inset-right, 0px));
    }
`;

export const AccordionButton = styled.div`
  position: absolute;
  bottom: -12px;
  background-color: rgb(224, 224, 224);
  width: 22px;
  height: 22px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transform: ${props => props.orientation ? 'rotate(180deg)' : 'none' };
`;

export const UsersTableCard = styled.div`
  margin-top: 22px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(21, 43, 78, 0.08);
  border: 1px solid rgba(21, 43, 78, 0.07);
  overflow: hidden;

  table thead tr,
  thead tr {
    background: linear-gradient(180deg, #eef1f6 0%, #e4e9f0 100%);
  }

  table thead th,
  thead th {
    border-bottom: 1px solid rgba(21, 43, 78, 0.12) !important;
    color: #152b4e !important;
    font-weight: 600 !important;
    font-size: 0.8rem !important;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  tbody tr {
    transition: background-color 0.15s ease;
  }
`;

export const UsersTabsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 10px 16px 0;
  border-bottom: 1px solid rgba(21, 43, 78, 0.15);
  background: #fff;

  @media (max-width: 800px) {
    gap: 8px;
    padding: 10px 10px 0;
    flex-wrap: wrap;
    align-items: flex-start;
  }
`;

export const UsersTabsTitle = styled.div`
  color: #152b4e;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;

  @media (max-width: 800px) {
    width: 100%;
    font-size: 11px;
  }
`;

export const UsersTabsItems = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 800px) {
    width: 100%;
    flex-wrap: wrap;
    gap: 6px;
  }
`;

export const UsersTabItem = styled.div`
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 6px 6px 0 0;
  border: 1px solid transparent;
  border-bottom: none;
  color: ${props => props.color || '#152b4e'};
  opacity: ${props => props.active ? 1 : 0.8};
  background: ${props => props.active ? 'rgba(21, 43, 78, 0.04)' : 'transparent'};
  transform: translateY(1px);

  @media (max-width: 800px) {
    font-size: 10px;
    padding: 4px 8px;
  }
`;

export const UsersPaginationWrap = styled.div`
  padding: 12px 16px 16px;
  border-top: 1px solid rgba(21, 43, 78, 0.07);
  background: linear-gradient(180deg, #f8fafc 0%, #fff 40%);
`;